import { ObjectValues } from '@beyonnex/bx-angular-ui';

export const DETAILS_PAGE_TABS = {
  DEVICE_STATUS: 'deviceStatus',
  DEVICE_DATA: 'deviceData',
  FEATURES: 'features',
  CONTEXT: 'context',
} as const;
export type DetailsPageTabId = ObjectValues<typeof DETAILS_PAGE_TABS>;
